import { hot } from 'react-hot-loader';
import * as React from 'react';
import Layout from 'app/containers/Layout';

export const App = hot(module)(() => <Layout />);
